/**
 * Path Service is a wrapper that handles $location needs for the app.
 * The aim is to provide path manipulation instead of using $location directly
 */
(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .factory('Path', PathFactory)
    ;

    function PathFactory($location, lodash, $window, $route) {
        var apiPath,
            structurePath,
            navPath = '',
            current,
            currentSplited,
            pathInfo;

        var ctrl = {
            getRelativePath: function (absPath) {
                return absPath.replace(/^(?:\/\/|[^\/]+)*\//, "/");
            },
            getPath: function (path) {
                if (typeof path == typeof []) {
                    path = path.join('/');
                }
                if (path.length < 1) {
                    path = 'index';
                }
                return path;
            },
            determinePathType: function (temp) {
                if (['new', 'edit', 'info', 'search'].indexOf(temp) > -1) {
                    return temp;
                }
                return 'id';
            },
            splitArray: function (path) {
                return path.substring(1).split('/');
            },
            decodeInteractPath: function(_interactPath) {
                var result = '',type = '';

                if (typeof _interactPath == 'string') {
                    _interactPath = _interactPath.split('/');
                }

                if (_interactPath.length == 0) {
                    return result;
                }

                switch (_interactPath.length) {
                    case 3:
                        type = this.determinePathType(_interactPath[2]);
                        result = {
                            modal: _interactPath[1],
                            tab: _interactPath[0],
                            id: _interactPath[2],
                            type: type
                        };
                        break;
                    case 2:
                        type = this.determinePathType(_interactPath[1]);
                        result = {
                            modal: _interactPath[0],
                            tab: '',
                            id: _interactPath[1],
                            type: type
                        };
                        break;
                    default:
                        //if (console) console.log('cannot determine interaction path');
                        result = "";
                }
                return result;
            },
            getParams: function(viewPath) {
                var split = viewPath.split('?');
                if (split.length < 2) {
                    return [];
                } else {
                    return split[1].split('&').map(function(paramText) {
                        var paramTextSplit = paramText.split('&');
                        var key = paramTextSplit[0];
                        var value = paramTextSplit[1] || null;
                        return { key: key, value: value };
                    });
                }
            },
            getStructurePath: function(viewPath) {
                return viewPath.split('?')[0];
            }
        };

        var PathInfo = function (splitedPath, search) {
            var viewPath, interactPath, decodedInteractPath, params, structurePath;

            var pathArr = angular.copy(splitedPath);
            if (pathArr.length < 4) {
                viewPath = pathArr.join('/');
                if (viewPath.length < 1) {
                    viewPath = 'index';
                }
                interactPath = '';
            } else {
                //var viewArr;

                //
                //if ('edit' == pathArr[3]) {
                //    viewArr = pathArr.splice(0, 4);
                //    viewPath = viewArr.join('/');
                //    interactPath = pathArr.join('/');
                //} else {
                //    viewArr = pathArr.splice(0, 3);
                //    viewPath = viewArr.join('/');
                //    interactPath = pathArr.join('/');
                //}
                viewPath = pathArr.join('/');
                interactPath = '';
            }

            decodedInteractPath = ctrl.decodeInteractPath(interactPath);
            params = ctrl.getParams(viewPath);
            structurePath = ctrl.getStructurePath(viewPath);

            return {
                viewPath: function () { return viewPath; },
                interactPath: function() { return decodedInteractPath; },
                search: function() { return search; },
                params: function() { return params; },
                structurePath: function() { return structurePath; },
            };
        };

        // Default Values, if init() is not called
        apiPath = "/";
        structurePath = "/";

        return {
            /*
             * set up Path on run
             */
            init: function (_structurePath, _apiPath) {
                apiPath = _apiPath;
                structurePath = _structurePath;
                this.change();
            },

            /*
             * Executes everything a path changes
             */
            change: function () {
                current = $location.path();
                var search = angular.copy($location.$$search);
                currentSplited = ctrl.splitArray(current);
                pathInfo = new PathInfo(currentSplited, search);
            },

            /*
             * Get Path, if index is provided, get the value of the position
             */
            get: function (position) {
                if (lodash.isNumber(position)) {
                    return currentSplited[position];
                }
                return false;
            },

            /*
             * redirect to desired destination
             */
            redirect: function (dest, searchData) {
                var _path = dest;
                if (_path.indexOf('<id>') > -1) {
                    _path = _path.replace(new RegExp('<id>', 'g'), this.get(2));
                }

                $location.path(_path);
                //sodo handle clearing the param strings
                if (!searchData) searchData = [];
                $location.search(searchData);
            },

            newTab: function(dest) {
                var _path = dest;
                if (_path.indexOf('<id>') > -1) {
                    _path = _path.replace(new RegExp('<id>', 'g'), this.get(2));
                }

                $window.open(_path);
            },

            newWindow: function(dest, title, options) {
                var _path = dest;
                if (_path.indexOf('<id>') > -1) {
                    _path = _path.replace(new RegExp('<id>', 'g'), this.get(2));
                }


                $window.open(_path, title, options);
            },

            reload: function(dest) {
                var _path = dest;
                if (_path.indexOf('<id>') > -1) {
                    _path = _path.replace(new RegExp('<id>', 'g'), this.get(2));
                }
                $window.location.href = _path;
            },

            /*
             * redirect up one level,
             */
            up: function () {
                var _path = pathInfo.viewPath().split('/');
                _path.splice(_path.length - 1, 1);
                return "/" + _path.join('/');
            },

            /*
             * get the stucture path base on current view
             */
            getStructurePath: function () {
                return structurePath + pathInfo.viewPath();
            },

            /**
             * get the interaction path base on current view
             */
            getInteractionPath: function() {
                return pathInfo.interactPath();
            },

            /*
             * get api path given a path
             */
            getApiPath: function (path) {
                return apiPath + ctrl.getPath(path);
            },

            /**
             * set master layout data path
             * @param _p
             */
            setMasterLayoutDataPath: function(_p) {
                navPath = _p;
            },

            /**
             * get master layout data path
             * @returns {*}
             */
            getMasterLayoutDataPath: function() {
                return navPath;
            },

            /*
             * get the module portion of the parth
             */
            getModule: function () {
                return this.get(0);
            },

            /*
             * Generates a pathinfo given a path string
             * @Params path: string, if path is empty, returns pathInfo variable
             * @Returns pathInfo: object
             */
            getPathInfo: function (path) {
                if (path) {
                    path = ctrl.splitArray(ctrl.getRelativePath(path));
                    return new PathInfo(path);
                }
                return pathInfo;
            },

            /**
             * Replace uri with id
             */
            replace: function(uri, subid) {
                var _path = angular.copy(uri);
                var id = this.get(2);
                //if (typeof id == typeof undefined) {
                //    id = this.get(2);
                //}

                if (_path.indexOf('<id>') > -1 ) {
                    _path = _path.replace(new RegExp('<id>','g'), id);
                }
                if (_path.indexOf('<subid>') > -1) {
                    _path = _path.replace(new RegExp('<subid>','g'), subid);
                }
                return _path;
            },

            /**
             * Adds Tabstrip Path
             */
            selectTabstrip: function(name) {
                if (this.get(3) === false) {
                    $location.path($location.path() + '/' + name);
                } else {
                    $location.path(this.get(0) + '/' + this.get(1) + '/' + this.get(2) + '/' + name);
                }
            },

            getRelativePath: function(pathName) {
                return ctrl.getRelativePath(pathName);
            },

            paramsIsDiff: function(params1, params2) {
                if (params1.length !== params2.length) {
                    return true;
                }
                var result = params1.reduce(function(r1, p1) {
                    var p2Match = lodash.find(params2, { key: p1.key });
                    if (!p2Match) {
                        r1.push(p1);
                    }
                    if (p2Match && p2Match.value != p1.value) {
                        r1.push(p1);
                    }
                    return r1;
                }, []);

                return (result.length > 0);
            }
        };
    }
})();